@if (layout === 'horizontal') {
<ul class="horizontal-menu" [ngClass]="{ 'flex-wrap': !noWrap }">
  @for (menu of menus; track menu) {
  <li>
    @if (!menu.subMenu && isExternalUrl(menu.link)) {
    <a [href]="menu.link">
      @if (menu.icon && menu.iconTheme) {
      <un-icon [type]="menu.icon" [theme]="menu.iconTheme"></un-icon>
      }
      <span>{{ menu.text }} </span>
    </a>
    } @if (!menu.subMenu && !isExternalUrl(menu.link)) {
    <a
      (click)="linkClick.emit(menu.link)"
      [routerLinkActive]="useFragmentService ? '' : 'active'"
      [ngClass]="{
        active:
          useFragmentService &&
          menu.fragment === (fragmentService.fragment | async)
      }"
      [routerLink]="menu.link"
      [routerLinkActiveOptions]="{
        fragment: menu.fragmentMatch || 'ignored',
        paths: menu.pathsMatch || 'subset',
        queryParams: 'ignored',
        matrixParams: 'ignored'
      }"
      [fragment]="menu.fragment"
    >
      @if (menu.icon && menu.iconTheme) {
      <un-icon [type]="menu.icon" [theme]="menu.iconTheme"></un-icon>
      }
      <span>{{ menu.text }} </span>
    </a>
    } @if (menu.subMenu) {
    <a
      [routerLinkActive]="useFragmentService ? '' : 'active'"
      [ngClass]="{
        active:
          useFragmentService &&
          menu.fragment === (fragmentService.fragment | async)
      }"
      (click)="linkClick.emit(menu.link)"
      [routerLink]="menu.link"
      [routerLinkActiveOptions]="{
        fragment: menu.fragmentMatch || 'ignored',
        paths: menu.pathsMatch || 'subset',
        queryParams: 'ignored',
        matrixParams: 'ignored'
      }"
      [fragment]="menu.fragment"
      nz-dropdown
      nzTrigger="hover"
      [nzDropdownMenu]="menuTpl"
    >
      @if (menu.icon && menu.iconTheme) {
      <un-icon [type]="menu.icon" [theme]="menu.iconTheme"></un-icon>
      }
      <span>{{ menu.text }} </span>
      @if (menu.subMenu) {
      <un-icon class="t-tiny" type="down" theme="outline"></un-icon>
      }
    </a>
    }
    <nz-dropdown-menu #menuTpl="nzDropdownMenu">
      <ul class="sub-menu">
        @for (subMenu of menu.subMenu; track subMenu) {
        <li>
          <a
            (click)="linkClick.emit(subMenu.link)"
            [routerLink]="subMenu.link"
            routerLinkActive="active"
            class="default"
          >
            @if (subMenu.icon && subMenu.iconTheme) {
            <un-icon
              [type]="subMenu.icon"
              [theme]="subMenu.iconTheme"
              class="t-large"
              [ngStyle]="subMenu.iconStyle"
            ></un-icon>
            }
            <div>
              <p class="t-medium">{{ subMenu.text }}</p>
              @if (subMenu.description) {
              <p class="t-small">
                {{ subMenu.description }}
              </p>
              }
            </div>
          </a>
        </li>
        }
      </ul>
    </nz-dropdown-menu>
  </li>
  }
</ul>
} @else {
<ul class="vertical-menu">
  @for (m of menus; track m; let i = $index) {
  <li>
    @if (!m.subMenu) {
    <a
      (click)="linkClick.emit(m.link)"
      [routerLink]="m.link"
      routerLinkActive="active"
      class="menu-item"
    >
      @if (m.icon && m.iconTheme) {
      <un-icon [type]="m.icon" [theme]="m.iconTheme"></un-icon>
      }
      <h5 class="t-medium">{{ m.text }}</h5>
    </a>
    } @if (m.subMenu) {
    <nz-collapse nzExpandIconPosition="end" [nzBordered]="false">
      <nz-collapse-panel [nzHeader]="menuTitle" [nzActive]="i === 0">
        <ng-template #menuTitle
          ><div class="menu-item">
            @if (m.icon && m.iconTheme) {
            <un-icon [type]="m.icon" [theme]="m.iconTheme"></un-icon>
            }
            <h5 class="t-medium">{{ m.text }}</h5>
          </div></ng-template
        >
        <ul class="submenu">
          @for (subMenu of m.subMenu; track subMenu) {
          <li>
            <a
              (click)="linkClick.emit(subMenu.link)"
              [routerLink]="subMenu.link"
              routerLinkActive="active"
              class="default"
            >
              @if (subMenu.icon && subMenu.iconTheme) {
              <un-icon
                [type]="subMenu.icon"
                [theme]="subMenu.iconTheme"
                class="t-large"
                [ngStyle]="subMenu.iconStyle"
              ></un-icon>
              }
              <div>
                <p class="t-medium">{{ subMenu.text }}</p>
                @if (subMenu.description) {
                <p class="t-small">
                  {{ subMenu.description }}
                </p>
                }
              </div>
            </a>
          </li>
          }
        </ul>
      </nz-collapse-panel>
    </nz-collapse>
    }
  </li>
  }
</ul>
}
